import Btn from '../utils/btn';

const func = $target => {
	var $form = $target.find('form'),
		$query = $target.find('input[name="q"]'),
		$btn = new Btn($target.find('button[type="submit"]')),
		value = $query.val();

	$btn.data('btn', 'false');
	$form.on('submit', function(e) {
		$btn.process();
		if ($query.val() == value) {
			$btn.processed();
		}
	});
};

export default func;
